import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@quark/design/dist/index.css";
import "@quark/questions/dist/index.css";
import "katex/dist/katex.css";
import App from "./App";
import { HashRouter } from "react-router-dom";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import LoginWrapper from "./component/login-wrapper";
import AssistantWrapper from "./component/assitant-wrapper";

dayjs.extend(isToday);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const Entry = () => {
  return (
    <HashRouter>
      <LoginWrapper>
        <AssistantWrapper>
          <App />
        </AssistantWrapper>
      </LoginWrapper>
    </HashRouter>
  );
};

if (import.meta.env.DEV) {
  root.render(<Entry />);
} else {
  root.render(
    <React.StrictMode>
      <Entry />
    </React.StrictMode>
  );
}
